import { useNavigate } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function ArticleCards() {
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-3">
          <div>
            <p className="text-xs tracking-widest uppercase text-accent-500 font-medium mb-2">
              SEO Ratgeber
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              OOPBUY Spreadsheet Wissen
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            Unsere besten Artikel rund um OOPBUY Spreadsheet, Shopping-Agenten und China-Import
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {seoArticles.map((article) => (
            <button
              key={article.slug}
              onClick={() => handleClick(article.fullPath)}
              className="group bg-white rounded-2xl overflow-hidden text-left hover:bg-background-50 transition-all duration-300 cursor-pointer block"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-white/90 text-foreground-800 text-xs font-medium px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.desc}
                </p>
                <span className="text-xs text-accent-500 font-medium flex items-center gap-1">
                  Weiterlesen
                  <i className="ri-arrow-right-line text-xs transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}